import React from "react";

function SelectedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#6E30E8"
        d="M13.833.467H2.167C1.242.467.5 1.217.5 2.133V13.8c0 .917.742 1.667 1.667 1.667h11.666c.925 0 1.667-.75 1.667-1.667V2.133c0-.916-.742-1.666-1.667-1.666zm-7.5 11.666L2.167 7.967l1.175-1.175 2.991 2.983 6.325-6.325 1.175 1.183-7.5 7.5z"
      ></path>
    </svg>
  );
}

export default SelectedIcon;
